import React, { useState } from 'react';
import './Members.css';

function Members(){
    return(
        <>
        {/**----------------------------member sect--------------------/ */}
        <div className="bloan-member">
          <div className="bloan-fs">
            <div className="bloan-f">
              <h4>2Cr+</h4>
              <p>Trusted members</p>
            </div>
            <div className="bloan-f">
              <h4>70+</h4>
              <p>Credit partners</p>
            </div>
            <div className="bloan-f">
              <h4>5k Cr</h4>
              <p>Loans disbursed</p>
            </div>
          </div>
        </div>

</>
    );
}
export default Members;
